export const COAC_JOURNEY_ACTIVE_KEY = 'mgo.coac.journeyActive';
export const DISPUTE_JOURNEY_ACTIVE_KEY = 'mgo.dispute.journeyActive';

const markActive = (key) => sessionStorage.setItem(key, 'true');
const clearActive = (key) => sessionStorage.removeItem(key);
const isActive = (key) => sessionStorage.getItem(key) === 'true';

/*
 * These flags are navigation hints only. They let the SPA resume the correct
 * screen after a reload, but never establish identity or authorize an API call.
 * The BFF session and ICOA grant decision remain authoritative.
 */
export const markCoacJourneyActive = () => markActive(COAC_JOURNEY_ACTIVE_KEY);
export const clearCoacJourneyActive = () => clearActive(COAC_JOURNEY_ACTIVE_KEY);
export const isCoacJourneyActive = () => isActive(COAC_JOURNEY_ACTIVE_KEY);

export const markDisputeJourneyActive = () => markActive(DISPUTE_JOURNEY_ACTIVE_KEY);
export const clearDisputeJourneyActive = () => clearActive(DISPUTE_JOURNEY_ACTIVE_KEY);
export const isDisputeJourneyActive = () => isActive(DISPUTE_JOURNEY_ACTIVE_KEY);
